import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * Servicio que expone los métodos de geoconsulta
 */
@Injectable({
  providedIn: 'root'
})
export class MapQueryService {

  constructor(private http: HttpClient) { }


  /**
   * Obtiene las coordenadas de una determinada localidad
   * @param ciudad
   * @returns
   */
  queryLocationByAddress(ciudad: string):Promise<any>{
    var url="https://www.mapquestapi.com/geocoding/v1/address?key=yp7iDxtCLfqrUn4XnSrY54QwLj4TYgOl&inFormat=kvp&outFormat=json";


    return new Promise((resolve,reject)=>{
      var options={params:{location:ciudad}};
      this.http.get(url,options).subscribe((response) => {
        let jresponse=response;
        console.log(jresponse)
        if(jresponse['results'].length>0){
          resolve(jresponse['results'][0].locations[0].latLng);
        }
      });
    });
  }
}
